import { DataGridPro } from "@mui/x-data-grid-pro"
import { styled } from "@cirrus/ui-kit/src"

export const StyledTable = styled(DataGridPro)({
  "& .MuiDataGrid-main *": {
    background: "transparent",
  },

  "& .MuiDataGrid-columnHeaders": {
    borderBottom: "none"
  },

  "& .MuiDataGrid-main .MuiDataGrid-cell": {
    borderBottom: "none !important",
    position: "relative",
  },

  "& .MuiDataGrid-columnHeader span": {
    fontSize: "12px",
  },

  "& .MuiDataGrid-columnHeader--sorted, & .MuiDataGrid-iconButtonContainer, & .MuiDataGrid-columnHeader--sortable:hover": {
    background: "transparent !important"
  },

  "& .MuiDataGrid-row .MuiDataGrid-cell": {
    alignItems: "center",
    padding: "0 16px",
  },

  "& .MuiDataGrid-row:hover": {
    background: "transparent !important",
    cursor: "default",
  },

  "& .MuiDataGrid-row > div:first-child": {
    fontWeight: "bold"
  },

  background: "#fafafa",
  borderRadius: "4px",
  border: "none !important",

  maxHeight: "500px"
})